import { render, staticRenderFns } from "./Ccoin.vue?vue&type=template&id=24bf2d60&lang=pug"
import script from "./Ccoin.vue?vue&type=script&lang=js"
export * from "./Ccoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports